export const OIDC_PROVIDERS = ['aws', 'azure', 'gcp', 'vault'] as const;

export type OidcProvider = (typeof OIDC_PROVIDERS)[number];

export const AWS_V2_OIDC_AUDIENCE = 'sts.amazonaws.com';
export const AZURE_V2_OIDC_AUDIENCE = 'api://AzureADTokenExchange';
export const GCP_V2_OIDC_AUDIENCE = 'api://env0-gcp';
export const VAULT_V2_OIDC_AUDIENCE = 'api://env0-vault';

const V2_OIDC_AUDIENCES = [
  AWS_V2_OIDC_AUDIENCE,
  AZURE_V2_OIDC_AUDIENCE,
  GCP_V2_OIDC_AUDIENCE,
  VAULT_V2_OIDC_AUDIENCE
] as const;

export type V2OidcAudience = (typeof V2_OIDC_AUDIENCES)[number];

export const isV2OidcAudience = (value: string): value is V2OidcAudience =>
  (V2_OIDC_AUDIENCES as readonly string[]).includes(value);

const V2_OIDC_AUDIENCE_TO_PROVIDER = {
  [AWS_V2_OIDC_AUDIENCE]: 'aws',
  [AZURE_V2_OIDC_AUDIENCE]: 'azure',
  [GCP_V2_OIDC_AUDIENCE]: 'gcp',
  [VAULT_V2_OIDC_AUDIENCE]: 'vault'
} as const satisfies Record<V2OidcAudience, OidcProvider>;

export const getOidcProviderForAudience = (audience?: string): OidcProvider | undefined =>
  audience !== undefined && isV2OidcAudience(audience) ? V2_OIDC_AUDIENCE_TO_PROVIDER[audience] : undefined;
